import React from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import Home from './paginas/Home'
import Ayuda from './paginas/Ayuda'
import CambioContraseña from './paginas/CambioContraseña'
import {OrdenConContexto} from './contexto/ContextoOrden'
import {RecargarSaldoConContexto} from './contexto/ContextoRecargarSaldo'
import ResultadosPaciente from './componentes/Ordenes/ResultadosPaciente'
import CrearOrden from './paginas/Ordenes/CrearOrden'
import EditarOrden from './paginas/Ordenes/EditarOrden'
import {RUTAS_APLICACION} from './constantes/rutas'
import RecargarSaldo from './paginas/PerfilContado/RecargarSaldo'
import DetalleYMovimientos from './paginas/PerfilContado/DetalleYMovimientos'
import FinalizarRecarga from './paginas/PerfilContado/FinalizarRecarga'
import GestionAtenciones from './paginas/PerfilContado/RecursosHumanos/GestionAtenciones'
import GestionDeOrdenes from './paginas/PerfilContado/RecursosHumanos/GestionDeOrdenes'
import OtrosServicios from './paginas/PerfilContado/OtrosServicios'
import CargaMasiva from './paginas/Ordenes/CargaMasiva'
import DescargaMasiva from './paginas/PerfilContado/DescargaMasiva'
import FinalizarRecargaOtrosServicios from './paginas/PerfilContado/FinalizarRecargaOtrosServicios'
import {MODULOS, RutaProtegida} from './autorizacion'

const proteger = (modulo, componente) => (
  <RutaProtegida modulo={modulo}>{componente}</RutaProtegida>
)

const Router = () => {
  return (
    <Routes>
      <Route
        path={RUTAS_APLICACION.ORDENES}
        element={proteger(MODULOS.GESTION_ORDENES, <GestionDeOrdenes />)}
      />

      <Route
        path={RUTAS_APLICACION.CARGA_MASIVA_ORDEN}
        element={proteger(MODULOS.ORDENES_MASIVAS, <CargaMasiva />)}
      />

      <Route
        path={RUTAS_APLICACION.GESTION_ATENCIONES}
        element={proteger(MODULOS.GESTION_ATENCIONES, <GestionAtenciones />)}
      />
      <Route
        path={RUTAS_APLICACION.CAMBIAR_CONTRASEÑA}
        element={<CambioContraseña />}
      />
      <Route path={RUTAS_APLICACION.AYUDA} element={<Ayuda />} />
      <Route
        path={RUTAS_APLICACION.RESULTADOS_PACIENTE}
        element={proteger(MODULOS.VER_PACIENTES, <ResultadosPaciente />)}
      />
      <Route
        path={RUTAS_APLICACION.CREAR_ORDEN}
        element={proteger(
          MODULOS.CREAR_ORDEN,
          <OrdenConContexto>
            <CrearOrden />
          </OrdenConContexto>,
        )}
      />
      <Route
        path={RUTAS_APLICACION.EDITAR_ORDEN}
        element={proteger(
          MODULOS.GESTION_ORDENES,
          <OrdenConContexto>
            <EditarOrden />
          </OrdenConContexto>,
        )}
      />
      <Route
        path={RUTAS_APLICACION.RECARGAR_SALDO}
        element={proteger(
          MODULOS.RECARGAR_CUENTA,
          <RecargarSaldoConContexto>
            <RecargarSaldo />
          </RecargarSaldoConContexto>,
        )}
      />
      <Route
        path={RUTAS_APLICACION.PAGAR_OTROS_SERVICIOS}
        element={proteger(
          MODULOS.PAGAR_OTROS_SERVICIOS,
          <RecargarSaldoConContexto>
            <OtrosServicios />
          </RecargarSaldoConContexto>,
        )}
      />
      <Route
        path={RUTAS_APLICACION.FINALIZAR_RECARGA_OTROS_SERVICIOS}
        element={proteger(
          MODULOS.PAGAR_OTROS_SERVICIOS,
          <RecargarSaldoConContexto>
            <FinalizarRecargaOtrosServicios />
          </RecargarSaldoConContexto>,
        )}
      />
      <Route
        path={RUTAS_APLICACION.FINALIZAR_RECARGA}
        element={proteger(
          MODULOS.RECARGAR_CUENTA,
          <RecargarSaldoConContexto>
            <FinalizarRecarga />
          </RecargarSaldoConContexto>,
        )}
      />
      <Route
        path={RUTAS_APLICACION.VER_DETALLE_Y_MOVIMIENTO}
        element={proteger(
          MODULOS.VER_DETALLE_MOVIMIENTO,
          <DetalleYMovimientos />,
        )}
      />
      <Route
        path={RUTAS_APLICACION.DESCARGA_MASIVA}
        element={proteger(MODULOS.DESCARGA_MASIVA, <DescargaMasiva />)}
      />
      <Route
        path={RUTAS_APLICACION.HOME}
        element={proteger(MODULOS.HOME, <Home />)}
      />
    </Routes>
  )
}
export default Router
